import { render } from "./TheManagerRentals.vue?vue&type=template&id=036daf18"
import script from "./TheManagerRentals.vue?vue&type=script&lang=js"
export * from "./TheManagerRentals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__